import { Component, OnInit } from '@angular/core';
import { ApiHandlerService } from '../api-handler.service'
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-poc-detail',
  templateUrl: './poc-detail.component.html',
  styleUrls: ['./poc-detail.component.css']
})
export class PocDetailComponent implements OnInit {

  constructor(private apiHandler: ApiHandlerService,  private router: ActivatedRoute, private route: Router) { }
  pocDetail = {
    title:null,
    info:null,
    toolsDetail:[],
    video:null,
    benefits:null,
    complexity:null,
    business:null,
    industry:null,
    technology:null,
    updatedOn:null,
    publishedOn:null,
    systemRequirements:[]
  };
  currentData = null;
  videoUrl=null
  ngOnInit() {
    window.scroll(0,0);
    this.router.params.subscribe(prm=>{
      if(prm['slug'] != undefined){
        this.getPOCDetail(prm['slug']);
      }
    })
  }

  getPOCDetail(slug){
    this.apiHandler.getPOCDetail(slug).subscribe(
      (result:any) => {
        this.pocDetail = this.getSystemRequirements(result.data);        
        this.videoUrl = this.pocDetail.video!= null? this.pocDetail.video:null;
        console.log("POC",this.pocDetail)
    },
    err=>{
      
      
    }
    )
  }

  public onClick($element): void { 
    $element.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
  }

  getSystemRequirements(item){
    try{
      if(item.systemRequirements != undefined){
        let sysKeyArray = Object.keys(item.systemRequirements)
        let systemReq = [];
        sysKeyArray.map(key => {
          let obj = {};
          obj["name"] = key;
          obj["value"] = item.systemRequirements[key];
          systemReq.push(obj);
        })
        item["systemRequirements"] = systemReq;
      }else{
        item["systemRequirements"] = [];
      }
      return item;
    }catch(er){
      item["systemRequirements"] = [];
      return item
    }
  }

  getToolsImage(tool){
    let toolsDetail = this.pocDetail.toolsDetail.find(x=>x.platformName == tool);
    if(toolsDetail){
      return toolsDetail.platformImage
    }else{
      return "https://omni-marketing-assets.s3.amazonaws.com/platforms/def_1.png"
    }
  }

}
